module.exports = __webpack_public_path__ + "img/business0.fa175582.jpg";